import { CatHeading } from '@blocks-react/components/Heading';
import { ChildProps } from '../../types';

export const CVAModalHeader = ({ children }: Readonly<ChildProps>) => {
  return (
    <CatHeading variant="title-sm" slot="header">
      {children}
    </CatHeading>
  );
};
